export enum AlertCondition {
	Above = 'Above threshold',
	Below = 'Below threshold',
}

export const ALERT_CONDITION_OPTIONS = [
	AlertCondition.Above,
	AlertCondition.Below,
]
